import { useAgentCreditAllowanceInChatChrome } from '@/components/ui/agent-credit-allowance-banner/useAgentCreditAllowanceInChatChrome';
import {
  WorkCreditAllowanceChromeProvider,
  type UseWorkCreditAllowanceChrome,
} from '@heidi/agents';
import { type ReactNode } from 'react';

const useWorkCreditAllowanceChrome: UseWorkCreditAllowanceChrome = (options) =>
  useAgentCreditAllowanceInChatChrome(true, options);

/** Layout-scoped. The adapter is one identity and is never conditional. */
export const WorkCreditAllowanceChromeHost = ({
  children,
}: {
  children: ReactNode;
}): JSX.Element => (
  <WorkCreditAllowanceChromeProvider useChrome={useWorkCreditAllowanceChrome}>
    {children}
  </WorkCreditAllowanceChromeProvider>
);
